import './styles.scss';
import {RouteComponentProps} from "react-router-dom";
import {useQuery} from "react-query";
import DefaultLoader from "../../components/common/DefaultLoader/DefaultLoader";
import OfficerDetails from "../../components/specific/Officers.details/Officers.details.component";
import OfficerApi from "../../api/Officer/Officer.api";

interface Props extends RouteComponentProps<{ officerId: string }> {

}

function OfficerContainer({ match }:Props){

    const {officerId} = match.params;
    const {isLoading, data} = useQuery([`singleOfficer-${match.params.officerId}`, officerId], OfficerApi.get)

    if (isLoading || !data) {
        return (
            <div className='default-loader-full'>
                <DefaultLoader text="Loading officer..."/>
            </div>
        )
    }

    return (
        <div className='officer-container'>
            <OfficerDetails officer={data}/>
        </div>
    )
}

export default OfficerContainer;